import React, { useState } from 'react';
import { Container, Row, Col, Card, Button, Modal } from 'react-bootstrap';
import { urlApi, storageUrl } from '../Constants/Global';
import NoPhoto from '../Medias/Photos/1655820470_0.webp';
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import Photo1 from '../Medias/Photos/client1.png';
import Public1 from '../Medias/Photos/1672481410_0.jpg';
import File1 from '../Medias/Photos/1672481281_0.pdf';
import Public2 from '../Medias/Docs/power-of-the-act-cover.png';
import File2 from '../Medias/Docs/power-of-the-act.pdf';
import Public3 from '../Medias/Docs/20230301_1.png';
import File3 from '../Medias/Docs/20230301_1.pdf';
import Public4 from '../Medias/Docs/20230301_2.png';
import File4 from '../Medias/Docs/20230301_2.pdf';
import Public5 from '../Medias/Docs/20230301_3.png';
import File5 from '../Medias/Docs/20230301_3.pdf';
import Public6 from '../Medias/Docs/2025-03-16.png';
import File6 from '../Medias/Docs/2025-03-16.pdf';
import Public7 from '../Medias/Docs/20250405_cover.png';
import File7 from '../Medias/Docs/20250405_publication.pdf';
import Public8 from '../Medias/Docs/tokenized.png';
import File8 from '../Medias/Docs/tokenized.pdf';
import Public9 from '../Medias/Docs/tok.png';
import File9 from '../Medias/Docs/tok.pdf';
import Public10 from '../Medias/Docs/EnergyTransition_PE13May2025.png';
import File10 from '../Medias/Docs/EnergyTransition_PE13May2025.pdf';
import Public11 from '../Medias/Docs/doc_2025-06.png';
import File11 from '../Medias/Docs/doc_2025-06.pdf';

const SectionEducational = ({ contents, youtubes }) => {
  // console.log('Load Publication :', contents);

  const [visibleItems, setVisibleItems] = useState(6);
  const [showModal, setShowModal] = useState(false);
  const [selectedContent, setSelectedContent] = useState(null);

  const loadMoreItems = () => {
    setVisibleItems(prevVisibleItems => prevVisibleItems + 6);
  };

  const handleViewContent = (content) => {
    setSelectedContent(content);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedContent(null);
  };

  return (
    <>
      <section id="knowledge" className='pt-5 pb-5'>
        <Container className='pt-5 pb-5'>
          <Row>
            {youtubes.map((item, index) => (
              <Col md={4} key={index} className='px-4 mx-auto'>
                <Card className='rounded-0 shadow border-0 mb-5'>
                  <Card.Img className='rounded-0' src={`../../${storageUrl}/media/${item.set5}`} />
                  <Card.Body>
                    <h5 className='tx-color-secondary text-uppercase mb-1'
                      style={{ cursor: 'pointer' }}
                      onClick={() => handleViewContent(item)}
                    >
                      {item.set1}
                    </h5>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <Modal show={showModal} onHide={handleCloseModal} size="lg">
        <Modal.Body className='p-4'>
          <div className='ratio-16x9 position-relative'>
            <iframe width="100%" height="100%" className='position-absolute' src={selectedContent?.set4} title={selectedContent?.set1} frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </div>
          <h5 className='mt-3'>{selectedContent?.set1}</h5>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

SectionEducational.defaultProps = {
  contents: [],
  youtubes: []
}

export default SectionEducational